import './toggleButton.css';

const ToggleButton = ({ options, selectedOption, onToggle }) => {
  const handleToggle = option => {
    onToggle(option);
  };

  if (options.length !== 2) {
    throw new Error('ToggleButton component must have exactly two options');
  }

  return (
    <div className="toggle-button">
      <div
        className={`toggle-option ${selectedOption === options[0].value ? 'selected' : ''}`}
        onClick={() => handleToggle(options[0].value)}
      >
        {options[0].label}
      </div>
      <div
        className={`toggle-option ${selectedOption === options[1].value ? 'selected' : ''}`}
        onClick={() => handleToggle(options[1].value)}
      >
        {options[1].label}
      </div>
    </div>
  );
};

export default ToggleButton;
